import { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../components/ui/Header";

export default function MockTestCamera() {
  const videoRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        videoRef.current.srcObject = stream;
      })
      .catch(() => alert("Camera permission required"));
  }, []);

  const startExam = async () => {
    await document.documentElement.requestFullscreen(); // USER gesture ✔
    navigate("/candidate/mock-test/start");
  };

  return (
    <div className="min-h-screen bg-black">
      <Header />

      <div className="flex flex-col items-center justify-center h-[calc(100vh-64px)] gap-6">
        <video
          ref={videoRef}
          autoPlay
          muted
          className="w-72 h-56 rounded-xl border"
        />

       <button
  onClick={() => {
    document.documentElement.requestFullscreen();
    navigate("/candidate/mock-test/start");
  }}
  className="bg-green-600 px-6 py-3 text-white rounded"
>
  Start Exam
</button>
      </div>
    </div>
  );
}
